import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function View() {
  const navigate = useNavigate();
  const { loggedAuth, userAuth } = useAuth();

  const role = userAuth?.role || "";

  useEffect(() => {
    if (!loggedAuth) {
      navigate("/login");
    } else {
      if (role === "superadmin") navigate("/dashboard");
      else {

        navigate("/user/dashboard");
      }
    }
  }, []);

  return <></>;
}

